<div class="row justify-content-center text-center">
    <div class="col-4 justify-content-center">
        <div class="card mt-3">
            <div class="card-body d-flex flex-column align-items-center">
                <img class="altrad-logo-md my-3" [src]="'./assets/images/'+ sharedDataSvc.pafEnvironment.logo" />
                <div class="my-3 text-primary"><H5>Votre compte a été bloqué ou vous n'êtes pas autorisé à accéder à cet écran.</H5></div>
                 
            </div>
        </div>

    </div>
</div>
